var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 11 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57812 2.06836C1.09277 2.06836 0.689453 1.66504 0.689453 1.17969C0.689453 0.6875 1.09277 0.291016 1.57812 0.291016C2.07031 0.291016 2.4668 0.6875 2.4668 1.17969C2.4668 1.66504 2.07031 2.06836 1.57812 2.06836ZM5.73438 2.06836C5.24902 2.06836 4.8457 1.66504 4.8457 1.17969C4.8457 0.6875 5.24902 0.291016 5.73438 0.291016C6.22656 0.291016 6.62305 0.6875 6.62305 1.17969C6.62305 1.66504 6.22656 2.06836 5.73438 2.06836ZM9.89062 2.06836C9.40527 2.06836 9.00195 1.66504 9.00195 1.17969C9.00195 0.6875 9.40527 0.291016 9.89062 0.291016C10.3828 0.291016 10.7793 0.6875 10.7793 1.17969C10.7793 1.66504 10.3828 2.06836 9.89062 2.06836Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotOptions);
export default __webpack_public_path__ + "static/media/dot_options.83abcb3a0fa87014fd4edd93c14e5ec3.svg";
export { ForwardRef as ReactComponent };